import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import BlogListPage from "./Pages/BlogListPage";
import HomePage from "./Pages/HomePage";
import ProjectPage from "./Pages/ProjectPage";
import Navbar from "./components/Navbar";
import Footer from "./views/Footer";
import PostPage from "./Pages/PostPage";

function App() {
  return (
    <div className="overflow-x-hidden max-w-[1500px] m-auto">
      <Navbar />
      <main className="min-h-[90vh] flex flex-col gap-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects/:slug" element={<ProjectPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<PostPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
